import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";
import { Image, Collapse } from "react-bootstrap";
//import HamburgurIconMenu from "./HamburgurIconMenu";
//import { IconButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import AddDinerPopup from "../../reusableComponents/allPopupReusable/addDinerAndAddReservation/AddDinerPopup";
// import OfferPopup from "../../reusableComponents/allPopupReusable/offerEventPopup/OfferPopup";
// import EventPopup from "../../reusableComponents/allPopupReusable/offerEventPopup/EventPopup";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { clear_all_errors } from "../../../store/actions/errorActions";
// import { logOutUser } from "../../../store/actions/authAction";
// import AddVendorSuggestionIssuesPopup from "../vendorOpenIssuesSuggestions/AddIssuesPopup/AddVendorSuggestionIssuesPopup";
// import AddUserTicketIssuesPopup from "../openIssuesVendor/AddUserTicketIssues/AddUserTicketIssuesPopup";
import {
  ReusableMenuLink,
  ReusableMenuLinkCollapse,
} from "../../vendorDashboardComponents/navigationSection/ReusableMenuLink";
import isEmpty from "../../../store/validation/is-Empty";
import SVG from "react-inlinesvg";
import Scrollbars from "react-custom-scrollbars";

import {
  create_and_update_restaurant,
  logOutUser,
} from "../../../store/actions/authAction";
import HamburgerMenuReusable from "./HamburgerMenuReusable";

export const SliderReusableComponent = ({
  // imageOne,
  // imageTwo,
  // imageThree,
  paragraphOne,
  paragraphTwo,
  paragraphThree,
  bottomImage,
  displayHamburger,
  displayBarButton,
  headingText,
  children,
  selectedProgressBarOne,
  selectedProgressBarTwo,
  selectedProgressBarThree,
  selectedProgressBarFour,
}) => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 login-section-one">
          <div className="login-top-right-nav">
            <NavLink to="/help">
              <i className="fa fa-question-circle-o" aria-hidden="true"></i>
            </NavLink>
          </div>
          {displayHamburger ? (
            // HamburgerMenu
            <HamburgerMenuReusable />
          ) : null}
        </div>
      </div>
      {displayBarButton ? (
        <div className="row">
          <div className="col-12 login-section-two">
            <div className={`boder-hr-line-gray ${selectedProgressBarOne}`}>
              <hr />
            </div>
            <div
              className={`number-navigation-box-gray ${selectedProgressBarOne}`}
            >
              1
            </div>
            <div className={`boder-hr-line-gray ${selectedProgressBarOne}`}>
              <hr />
            </div>
            <div
              className={`number-navigation-box-gray ${selectedProgressBarTwo}`}
            >
              2
            </div>
            <div className={`boder-hr-line-gray ${selectedProgressBarTwo}`}>
              <hr />
            </div>
            <div
              className={`number-navigation-box-gray ${selectedProgressBarThree}`}
            >
              3
            </div>
            <div className={`boder-hr-line-gray ${selectedProgressBarThree}`}>
              <hr />
            </div>
            <div
              className={`number-navigation-box-gray ${selectedProgressBarFour}`}
            >
              4
            </div>
            <div className={`boder-hr-line-gray ${selectedProgressBarFour}`}>
              <hr />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {children}
      <div className="f24_700_HelveticaNeue text-center">{headingText}</div>
      <div className="row">
        <div className="login-section-three">
          <Carousel
            className="login-screen-slider-main"
            activeIndex={index}
            onSelect={handleSelect}
          >
            <Carousel.Item className="carousel-item-slider">
              <Carousel.Caption className="slider-new-captions">
                <p>{paragraphOne}</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="carousel-item-slider">
              <Carousel.Caption className="slider-new-captions">
                <p>{paragraphTwo}</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="carousel-item-slider">
              <Carousel.Caption className="slider-new-captions">
                <p>{paragraphThree}</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <div
        className="row position-absolute m-auto fixed-bottom"
        style={{ zIndex: "0" }}
      >
        <div className="login-section-four">
          <div className="login-screen-right-image">
            <img
              className="img-fluid"
              src={bottomImage}
              alt="Amealio"
              title="Amealio"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const CasualFineDiningCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openCasualFineDining}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/offers"
                  : "/fastfood/offers"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/scanandpay"
                  : "/fastfood/scanandpay"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/livestreaming"
                  : "/fastfood/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/ordering"
                  : "/fastfood/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/generalseating"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>General Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Walk-In/Wait List</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/reservation"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Reservations</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/table"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Table Management</h4>
                          </NavLink>
                        ) : null} */}
            {/* <NavLink
                          exact
                          to={
                            subscriptionLocal && subscriptionLocal.casualDiningManagement
                              ? "/casual-fine-dining/menusetup"
                              : "/fastfood/menusetup"
                          }
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Ordering</h4>
                        </NavLink> */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/menusetup"
                  : "/fastfood/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

const FastFoodCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openFastFoodAndOther}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/offers"
                  : "/fastfood/offers"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/scanandpay"
                  : "/fastfood/scanandpay"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/livestreaming"
                  : "/fastfood/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/ordering"
                  : "/fastfood/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/generalseating"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>General Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Walk-In/Wait List</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/reservation"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Reservations</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/table"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Table Management</h4>
                          </NavLink>
                        ) : null} */}
            {/* <NavLink
                          exact
                          to={
                            subscriptionLocal && subscriptionLocal.casualDiningManagement
                              ? "/casual-fine-dining/menusetup"
                              : "/fastfood/menusetup"
                          }
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Ordering</h4>
                        </NavLink> */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/menusetup"
                  : "/fastfood/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

const HospitalityAndHotelsCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openHospitalityAndHotels}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/offers"
                  : "/fastfood/offers"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/scanandpay"
                  : "/fastfood/scanandpay"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/livestreaming"
                  : "/fastfood/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/ordering"
                  : "/fastfood/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/generalseating"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>General Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Walk-In/Wait List</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/reservation"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Reservations</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/table"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Table Management</h4>
                          </NavLink>
                        ) : null} */}
            {/* <NavLink
                          exact
                          to={
                            subscriptionLocal && subscriptionLocal.casualDiningManagement
                              ? "/casual-fine-dining/menusetup"
                              : "/fastfood/menusetup"
                          }
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Ordering</h4>
                        </NavLink> */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/menusetup"
                  : "/fastfood/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};

const MultiBusinessServiceCollapse = (props) => {
  const state = props.state;
  const subscriptionLocal = props.subscriptionLocal;

  return (
    <React.Fragment>
      <Collapse in={state.openMultiBusinessServices}>
        <div id="example-collapse-text">
          <div className="example-collapse-text-inside">
            <NavLink exact to="/subscription" className="empty-div-selected">
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                alt="Dashboard Icon"
              />
              <h4>Listing Service</h4>
            </NavLink>
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/offers"
                  : "/fastfood/offers"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/tag.svg")}
                alt="Dashboard Icon"
              />
              <h4>Offers Management</h4>
            </NavLink>

            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/scanandpay"
                  : "/fastfood/scanandpay"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/qr.svg")}
                alt="Dashboard Icon"
              />
              <h4>Scan & Pay</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/events"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/event.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Events Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/livestreaming"
                  : "/fastfood/livestreaming"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/live-streaming.svg")}
                alt="Dashboard Icon"
              />
              <h4>Live Streaming</h4>
            </NavLink>
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement"
                className="empty-div-selected"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/generalseating"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                  alt="Dashboard Icon"
                />
                <h4>General Seating</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Walk-In/Wait List</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/reservation"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Reservations</h4>
              </NavLink>
            ) : null}
            {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
              <NavLink
                exact
                to="/casual-fine-dining/seatingmanagement/table"
                className="empty-div-selected sub"
              >
                <SVG
                  src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                  alt="Dashboard Icon"
                />
                <h4>Table Management</h4>
              </NavLink>
            ) : null}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/ordering"
                  : "/fastfood/ordering"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                alt="Dashboard Icon"
              />
              <h4>Ordering</h4>
            </NavLink>
            {/* {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement"
                            className="empty-div-selected"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/generalseating"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/waiting-room.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>General Seating</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/walkinwaitlist"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/subscription.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Walk-In/Wait List</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/reservation"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Reservations</h4>
                          </NavLink>
                        ) : null}
                        {subscriptionLocal && subscriptionLocal.casualDiningManagement ? (
                          <NavLink
                            exact
                            to="/casual-fine-dining/seatingmanagement/table"
                            className="empty-div-selected sub"
                          >
                            <SVG
                              src={require("../../../assets/images/RightNavigationIcon/Calendar.svg")}
                              alt="Dashboard Icon"
                            />
                            <h4>Table Management</h4>
                          </NavLink>
                        ) : null} */}
            {/* <NavLink
                          exact
                          to={
                            subscriptionLocal && subscriptionLocal.casualDiningManagement
                              ? "/casual-fine-dining/menusetup"
                              : "/fastfood/menusetup"
                          }
                          className="empty-div-selected"
                        >
                          <SVG
                            src={require("../../../assets/images/RightNavigationIcon/ordering.svg")}
                            alt="Dashboard Icon"
                          />
                          <h4>Ordering</h4>
                        </NavLink> */}
            <NavLink
              exact
              to={
                subscriptionLocal && subscriptionLocal.casualDiningManagement
                  ? "/casual-fine-dining/menusetup"
                  : "/fastfood/menusetup"
              }
              className="empty-div-selected"
            >
              <SVG
                src={require("../../../assets/images/RightNavigationIcon/buffet.svg")}
                alt="Dashboard Icon"
              />
              <h4>Menu setup</h4>
            </NavLink>
          </div>
        </div>
      </Collapse>
    </React.Fragment>
  );
};
